<template>
  <div
    v-style="gradient"
    class="w-full absolute"
    :class="{
      'top-0': position === 'top',
      'bottom-0': position === 'bottom',
    }"
  />
</template>

<script setup lang="ts">
import type { Responsive } from '#types/common'
import type { GradientStyle } from '#types/styles'

const {
  gradientTone = 'transparent',
  gradientBreakpoints,
  gradientStyle,
} = defineProps<{
  position: 'top' | 'bottom'
} & GradientStyle>()

const gradientStyles = { full: 35, focused: 50 }

const gradient = {
  display: Object.entries(gradientBreakpoints!).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: value ? 'block' : 'none'
  }), {} as Responsive),
  bgv: `linear-gradient(to bottom, transparent, ${gradientTone || 'transparent'})`,
  h: `${gradientStyles[gradientStyle!] || 0}%`,
}
</script>
